import type { TaskTypeT } from 'shared/constants'

export const getTaskTypeTexts = (taskType: TaskTypeT) => {
  switch (taskType) {
    case 'shift_update':
      return { title: 'tasks.delete.shift_update.title', body: 'tasks.delete.shift_update.body' }
    case 'monthly_sheet':
      return { title: 'tasks.delete.monthly_sheet.title', body: 'tasks.delete.monthly_sheet.body' }
    case 'absence_request':
      return { title: 'tasks.delete.absence_request.title', body: 'tasks.delete.absence_request.body' }
    case 'share_user_data':
      return { title: 'tasks.delete.share_user_data.title', body: 'tasks.delete.share_user_data.body' }
    case 'secure_connection':
      return { title: 'tasks.delete.secure_connection.title', body: 'tasks.delete.secure_connection.body' }
    default:
      return { title: '', body: '' }
  }
}
